export default {
  validation: {
    required: 'Dit veld is verplicht',
    short: 'De ingevoerde waarde is te kort',
    long: 'De ingevoerde waarde is te lang',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js